import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { shop as shopRepository } from "@/repositories/shop";
import { Shop } from "@/types/v2";
import { Loading } from "@/components/Page/Loading";
import { SupportLink } from "@/components/Common/SupportLink";
import { AuthFormHeader } from "@/components/Auth/AuthFormHeader";
import { useIsNotGuest } from "@/hooks/useIsNotGuest";

export const SubscriptionReturnPage = () => {
  useIsNotGuest();
  const [searchParams] = useSearchParams();
  const [shop, setShop] = useState<Shop>();
  const success = searchParams.get("success");
  const shopId = searchParams.get("shopId");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (shopId) {
      shopRepository
        .get(shopId)
        .then((shop) => {
          setShop(shop);
        })
        .finally(() => setLoading(false));
    }
  }, [shopId]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (success === "true" && shop) {
      timeoutId = setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [success, shop]);

  if (loading) return <Loading />;

  if (success === "true" && shop) {
    return (
      <div className="m-auto flex flex-col gap-4 bg-slate-900 text-slate-100">
        <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
          <div className="w-full max-w-md space-y-8 rounded-xl border-2 border-white bg-secondary/10 p-8">
            <AuthFormHeader
              title="Congratulations!"
              instructions="You have successfully created a shop and activated a subscription. Visit your shop by clicking the link below, or just wait and we will redirect you in a few seconds."
            />
            <div className="flex flex-col items-center gap-4">
              <a href={"/"} className="text-center">
                {`Visit ${shop?.name ?? "Your Shop"}`}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="m-auto flex flex-col gap-4 bg-slate-900 text-slate-100">
      <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8 rounded-xl border-2 border-white bg-secondary/10 p-8">
          <AuthFormHeader
            title="Uh-Oh!"
            instructions="We did not recieve a confirmation on your subscription. Please contact support if this was an error. You have been granted a one-time trial. Visit your shop by clicking the link below."
          />
          <div className="flex flex-col items-center gap-4">
            <SupportLink>Contact Support</SupportLink>
            <a href={"/"} className="text-center">
              {`Visit ${shop?.name ?? "Your Shop"}`}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
